module.exports = "<i class=\"fa\" [ngClass]=\"iconClass\" (click)=\"copyContent()\"></i>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/copy-clipboard/copy-clipboard.component.html
// module id = ./src/app/shared/copy-clipboard/copy-clipboard.component.html
// module chunks = main